import { CFG_NODE_API_BASE, SPORT_LIST, SPORT_IDS } from "../../../assets/js/config";

const { fetchMatchCodeFromString, startHTTPRequest, calcTime, daysBetween, getDateString } = require("../../../assets/js/common");

let getCustomDateTimeObj = (t, e, a) => {
    let i = t.split("T");
    let start_date = i[0] + "T" + e + a;

    let start_time = new Date(
        calcTime(new Date(start_date))
    );
    let current_date = new Date();
    let dateObj = daysBetween(current_date, start_time, start_date);
    return {
        start_time,
        is_started: dateObj.is_expired,
        series_year: dateObj.series_year,
        custom_date: dateObj.custom_date,
        custom_time: dateObj.custom_time
    }
};

let isDateExpired = (end_date) => {
    let end_time = new Date(
        calcTime(new Date(end_date))
    );
    let current_date = new Date();
    let dateObj = daysBetween(current_date, end_time, end_date);
    return dateObj.is_expired;
};

let getSeriesSpan = (start, end) => {
    let {match_date: first_date, match_time: first_time, gmt_offset: first_offset} = start;
    let {match_date: last_date, match_time: last_time, gmt_offset: last_offset} = end;
    
    let sd = first_date.split("T");
    let start_date = sd[0] + "T" + first_time + first_offset;
    let ed = last_date.split("T");
    let end_date = ed[0] + "T" + last_time + last_offset;
    let sYear = getDateString(start_date, 'year');
    let eYear = getDateString(end_date, 'year');
    let sMonth = getDateString(start_date, 'month', {month: "short"});
    let eMonth = getDateString(end_date, 'month', {month: "short"});
    let sDay = getDateString(start_date, 'day_abb');
    let eDay = getDateString(end_date, 'day_abb');
    if(sYear === eYear) {
        return `${sDay} ${sMonth} - ${eDay} ${eMonth} ${eYear} `;
    } else {
        return `${sDay} ${sMonth} ${sYear} - ${eDay} ${eMonth} ${eYear} `;
    }
}

let getTeamName = (match) => {
    return `${match.team1_code} vs ${match.team2_code}, ${match.series_year}`;
}

const serieslanding = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.serieslanding) ? window.__ROI_STATE_DATA__.serieslanding : {
        landing_store_filled: false,
        tabIds: {
            'result': 1,
            'upcoming': 2,
            'ptsTable': 3
        },
        selected_series: -1,
        selectedTabId: null,
        seriesName: "",
        seriesSportId: null,
        seriesSportName: "",
        totalMatches: "",
        totalTeams: 0,
        seriesDuration: "",
        matchNameYear: "",
        resultMatches: [],
        upcomingMatches: [],
        pointsTable: []
    }),
    actions: {
        fetchSeriesInfo: ({ state, rootState }, {tabName}) => {
            let { route } = rootState;
            let seriesCode = null, sport_id = 1, defaultTab = state.tabIds.upcoming;
            if (route && route.params && route.params.series_slug) {
                let seriesSlug = route.params.series_slug;
                if (seriesSlug.indexOf('-series-') > -1) {
                    seriesCode = fetchMatchCodeFromString(seriesSlug);
                    let sportInSlug = seriesSlug.split('-')[0];
                    let sportObjInSlug = SPORT_LIST.find(s => s.name.toLocaleLowerCase() == sportInSlug.toLocaleLowerCase());
                    if(sportObjInSlug) {
                        sport_id = sportObjInSlug.id;
                    }
                    if(tabName && state.tabIds[tabName]){
                        defaultTab = state.tabIds[tabName];
                    }
                }
            }
            state.selectedTabId = defaultTab;

            if (seriesCode) {
                if(sport_id == SPORT_IDS.football) {
                    state.landing_store_filled = true;
                } else {
                    let actionData = {
                        method: "GET",
                        url: `${CFG_NODE_API_BASE}series/get-series-info`,
                        params: {
                            series_id: seriesCode
                        },
                        can_append: false
                    };
    
                    return startHTTPRequest(actionData)
                        .then((res) => {
                            let { series_id, series_name, sport_name, sport_id, total_matches, total_teams, series_matches, points_table } = res;
                            state.selected_series = series_id;
                            state.seriesName = series_name;
                            state.seriesSportName = sport_name;
                            state.seriesSportId = sport_id;
                            state.totalMatches = total_matches;
                            state.totalTeams = total_teams;
                            
                            if (series_matches && series_matches.length) {
                                let matches = series_matches.map(m => {
                                    if(m.match_date && m.match_time && m.gmt_offset) {
                                        let dateObj = getCustomDateTimeObj(m.match_date, m.match_time, m.gmt_offset);
                                        m.match_start_date_time = dateObj.start_time;
                                        m.custom_date = dateObj.custom_date;
                                        m.custom_time = dateObj.custom_time;
                                        m.series_year = dateObj.series_year;
                                        if(m.match_state == "t" || m.match_state == "c") {
                                            let isMatchCompleted = isDateExpired(m.match_end_date);
                                            if(isMatchCompleted) {
                                                m.match_state = "c";
                                            } else {
                                                m.match_state = "t";
                                            }
                                            if(dateObj.is_started && !isMatchCompleted) {
                                                m.isLive = true; // detecting live state of a match
                                            }
                                        }
                                    }
                                    return m;
                                }).sort((a, b) => {
                                    if (a.match_start_date_time < b.match_start_date_time) { return -1; }
                                    if (a.match_start_date_time > b.match_start_date_time) { return 1; }
                                    return 0;
                                });

                                let firstMatch = matches[0];
                                state.matchNameYear = getTeamName(firstMatch);
                                let lastMatch = matches[matches.length-1];
                                state.seriesDuration = getSeriesSpan(firstMatch, lastMatch);
    
                                state.resultMatches = matches.filter(m => m.match_state === "c").sort((a, b) => {
                                    if (a.match_start_date_time > b.match_start_date_time) { return -1; }
                                    if (a.match_start_date_time < b.match_start_date_time) { return 1; }
                                    return 0;
                                });
                                state.upcomingMatches = matches.filter(m => (m.match_state === "t" || m.match_state === "u"));
                                state.pointsTable = points_table;
                            }
                            state.landing_store_filled = true;
                        })
                        .catch((e) => {
                            console.log(e);
                            console.log(e.toString());
                            state.landing_store_filled = true;
                        });
                }
            } else {
                state.landing_store_filled = true;
            }
        }
    }
}

export default serieslanding;